import { uuidv7 } from 'uuidv7';
export async function createAddress(tx, address, userId) {
    const newAddress = {
        id: uuidv7(),
        country: address.country,
        region: address.region,
        city: address.city,
        postalCode: address.postalCode,
        addressLine: address.addressLine,
        additionalInfo: address.additionalInfo,
        createdAt: Date.now(),
        createdBy: userId,
    };
    await tx.mutate.addresses.insert(newAddress);
    return newAddress;
}
export async function updateAddress(tx, addressId, address, userId) {
    const updatedAddress = {
        id: addressId,
        country: address.country,
        region: address.region,
        city: address.city,
        postalCode: address.postalCode,
        addressLine: address.addressLine,
        additionalInfo: address.additionalInfo,
        updatedAt: Date.now(),
        updatedBy: userId,
    };
    await tx.mutate.addresses.update(updatedAddress);
    return updatedAddress;
}
//# sourceMappingURL=address-utils.js.map